<script lang="ts" setup>
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

const props = withDefaults(
  defineProps<{
    isSupermins?: boolean
  }>(),
  { isSupermins: false }
)

const pointsName = computed(() => props.isSupermins ? 'Supermins' : 'iTAB Плюс')

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Кешбэк баллами {{ pointsName }}
    </template>

    <p v-if="!isSupermins">
      Начисляем до&nbsp;2% от&nbsp;суммы товаров, если не&nbsp;списываете баллы, иначе&nbsp;— до&nbsp;1%.
    </p>

    <p>Кешбэк рассчитывается от&nbsp;фактически уплаченной денежными средствами стоимости товаров после применения всех скидок, баллов и&nbsp;сертификатов.</p>

    <p>Баллы {{ pointsName }} начисляются только вошедшим на&nbsp;сайт пользователям за&nbsp;покупку {{ isSupermins ? 'без промокода и\xA0баллов' : 'без промокода' }}.</p>

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
